'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FREE_GIFT_TIER_PROPERTY_KEY = exports.FREE_GIFT_TIER_PROPERTY_KEY = '__Free Gift';
var FREE_GIFT_CODE_PROPERTY_KEY = exports.FREE_GIFT_CODE_PROPERTY_KEY = '__Free Gift from Code';
var FREE_GIFT_CODE_SUFFIX_KEY = exports.FREE_GIFT_CODE_SUFFIX_KEY = '__Free Gift Code Suffix';
var FREE_GIFT_THRESHOLD_PROPERTY_KEY = exports.FREE_GIFT_THRESHOLD_PROPERTY_KEY = '__Free Gift Threshold';
var FREE_GIFT_THRESHOLD_MAX_PROPERTY_KEY = exports.FREE_GIFT_THRESHOLD_MAX_PROPERTY_KEY = '__Free Gift Threshold Max';
var FREE_GIFT_CODE_ATTRIBUTE_KEY = exports.FREE_GIFT_CODE_ATTRIBUTE_KEY = 'Claimed Free Code Gift';

var MIX_AND_MATCH_SHELL_PROPERTY_KEY = exports.MIX_AND_MATCH_SHELL_PROPERTY_KEY = '__MixAndMatchShell';
var MIX_AND_MATCH_CHILD_PROPERTY_KEY = exports.MIX_AND_MATCH_CHILD_PROPERTY_KEY = '__MixAndMatchChild';
var MIX_AND_MATCH_CHILD_IS_FIRST_PROPERTY_KEY = exports.MIX_AND_MATCH_CHILD_IS_FIRST_PROPERTY_KEY = '__MixAndMatchChildIsFirst';
var MIX_AND_MATCH_TITLE_PROPERTY_KEY = exports.MIX_AND_MATCH_TITLE_PROPERTY_KEY = '__MixAndMatchTitle';
var MIX_AND_MATCH_IMAGE_PROPERTY_KEY = exports.MIX_AND_MATCH_IMAGE_PROPERTY_KEY = '__MixAndMatchImage';
var MIX_AND_MATCH_URL_PROPERTY_KEY = exports.MIX_AND_MATCH_URL_PROPERTY_KEY = '__MixAndMatchUrl';
var MIX_AND_MATCH_CHILD_PRODUCTS_PROPERTY_KEY = exports.MIX_AND_MATCH_CHILD_PRODUCTS_PROPERTY_KEY = '__ChildrenProducts';
var MIX_AND_MATCH_SHELL_PRICE_PROPERTY_KEY = exports.MIX_AND_MATCH_SHELL_PRICE_PROPERTY_KEY = '__ChildrenProductsPrice';
var MIX_AND_MATCH_ID_PROPERTY_KEY = exports.MIX_AND_MATCH_ID_PROPERTY_KEY = '__MixAndMatchID';
var MIX_AND_MATCH_MINI_PROPERTY_KEY = exports.MIX_AND_MATCH_MINI_PROPERTY_KEY = '__MixAndMatchMini';
var MIX_AND_MATCH_TYPE_PROPERTY_KEY = exports.MIX_AND_MATCH_TYPE_PROPERTY_KEY = '__MixAndMatchType';